export default __webpack_public_path__ + "static/media/47.c00c0ae9.jpeg";